/*eslint-disable */
import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from 'reactstrap'

import { motion } from 'framer-motion'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleRight,
  faAngleLeft,
  faHeading,
  faFont,
  faVideo,
  faFile,
  faCode,
  faFileArchive,
  faLink,
  faCheck,
  faTimes,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'

import '../style.css'
import DrawerNav from './DrawerNav'
import { useDispatch, useSelector } from 'react-redux'
import Notes from './Notes'
import Rating from './Rating'
import { assignUserToCourse } from 'store/AllCourses/actions'
import { fetchTrainingSession } from 'store/Course/actions'
import AxiosInstance from 'utils/AxiosInstance'
import { setQuizCloseOverlay } from 'store/Quiz/actions'
import { toggleFeedbackOverlay } from 'store/Course/actions'
import { Link, useLocation } from 'react-router-dom'
import { finishContent } from 'store/Course/actions'
import { setShowCertificate } from 'store/Course/actions'
import Certificate from 'views/pages/Certificate'
import FeedbackOverlay from './Feedback'
import Submission from 'views/pages/LearningPlan/Quiz/Submission'
import Question from 'views/pages/LearningPlan/Quiz/Question'
import InputRadio from 'views/pages/LearningPlan/Quiz/Inputs/InputRadio'
import InputCheckbox from 'views/pages/LearningPlan/Quiz/Inputs/InputCheckBox'
import Loader from 'views/pages/Loader'
import { increaseIframeKey } from 'store/Course/actions'
import CustomModalHeader from 'components/Custom/CustomModalHeader'
import CustomModalFooter from 'components/Custom/CustomModalFooter'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { fetchContents } from 'store/Course/actions'
import DiscussionForum from './DiscussionForum'
import { toggleNewExternalReportOverlay } from 'store/ExternalReports/actions'
import GridQuestions from '../../components/GridQuestions'
import { fetchUserProgressByCourseId } from 'store/Course/actions'
import CompletionFeedbackModal from '../CompletionFeedbackModal'
import CompletionTermsModal from '../CompletionTermsModal'
import { hasAlreadyGivenCompletionFeedback } from 'store/Course/actions'
import { hasCompletedTerms as hasCompletedTermsFunction } from 'store/Course/actions'
function Drawer({
  show,
  setShow,
  course,
  access,
  userQuiz,
  theme,
  user,
  general,
}) {
  const userLanguage = useSelector((state) => state.language)
  const courseConfig = useSelector((state) => state.courseConfig)
  const allCourses = useSelector((state) => state.allCourses)
  const agreementContent = useSelector(
    (state) => state.courseConfig.agreementContent
  )

  const shouldCertificateBlink = courseConfig?.enableCertificateBlinking === 1
  const shouldEmailCertificate = courseConfig?.enableEmailCertificate === 1

  const courses = useSelector((state) => state.courses)
  const hasGivenFeedBack = courses?.hasGivenFeedBack
  const hasCompletedTerms = courses?.hasCompletedTerms

  const [isInvited, setIsInvited] = useState(false)
  const [isAccepted, setIsAccepted] = useState(false)
  const [isTrainingOver, setIsTrainingOver] = useState(false)
  const [showViewSubmission, setShowViewSubmission] = useState(false)

  const [showFeedbackModal, setShowFeedbackModal] = useState(false)
  const [showAgreementModal, setShowAgreementModal] = useState(false)

  const [showCert, setShowCert] = useState(false)

  const [showModal, setShowModal] = useState(false)

  const location = useLocation()

  const dispatch = useDispatch()

  const isSelfAssignableCourse = course.selfAssignable
  const assignedCourse = allCourses?.assignedCourses.find(
    (item) => item.course_id === course.course_id
  )
  const enableCompletionFeedback = course?.enableCompletionFeedback
  const requireAgreement = course?.requireAgreement

  const toggleShowModal = () => {
    setShowModal(!showModal)
    // dispatch(() => toggleNewExternalReportOverlay())
  }

  const currentCourse = course.currentCourse ? course.currentCourse : null

  const allowedAttempts = course.quizAttemptsAllowed
    ? course.quizAttemptsAllowed
    : null

  let courseStatus = null
  const currentCourseProgress = course.userProgress.find(
    (item) => item.course_id === course.course_id
  )
  if (currentCourseProgress) {
    courseStatus = currentCourseProgress.status
    course['certifyTime'] = currentCourseProgress.certify_time
  }

  let language = {}
  userLanguage.language ? (language = userLanguage.language.data) : null

  const checkTraining = (trainingId) => {
    AxiosInstance.get(`/training-session/check/${trainingId}`).then(
      (response) => {
        setIsInvited(response.is_invited)
        setIsAccepted(response.accepted)
        setIsTrainingOver(response.training_over)
      }
    )
  }

  const handleDrawer = () => {
    setShow(!show)
  }

  useEffect(() => {
    if (course.finishedContent.length) {
      dispatch(fetchContents(course.id, userLanguage?.language?.id))
    }
  }, [course.finishedContent.length])

  const [blink, setBlink] = useState(false)

  useEffect(() => {
    setBlink(true)
  }, [courseStatus])

  useEffect(() => {
    if (
      course?.content?.[course.content.length - 1]?.completed &&
      !currentCourse
    ) {
      dispatch(fetchUserProgressByCourseId(course?.course_id))
    }
  }, [course, currentCourse, dispatch])

  useEffect(() => {
    dispatch(hasAlreadyGivenCompletionFeedback(course.id))
  }, [dispatch, course.id])

  useEffect(() => {
    dispatch(hasCompletedTermsFunction(course.id))
  }, [dispatch, course.id])

  useEffect(() => {
    if (
      enableCompletionFeedback &&
      course.content[course.content.length - 1]?.completed &&
      course.id &&
      !hasGivenFeedBack
    ) {
      setShowFeedbackModal(true)
    }
  }, [enableCompletionFeedback, course.content, hasGivenFeedBack, course.id])

  const [feedbackCondition, setFeedbackCondition] = useState(true)

  useEffect(() => {
    if (enableCompletionFeedback) {
      if (!hasGivenFeedBack) {
        setFeedbackCondition(false)
      } else {
        setFeedbackCondition(true)
      }
    }
  }, [enableCompletionFeedback, hasGivenFeedBack])

  useEffect(() => {
    if (
      requireAgreement &&
      feedbackCondition &&
      !hasCompletedTerms &&
      course.id &&
      course.content?.[course.content.length - 1]?.completed
    ) {
      setShowAgreementModal(true)
    }
  }, [
    requireAgreement,
    feedbackCondition,
    hasCompletedTerms,
    course.id,
    course.content,
    setShowAgreementModal,
  ])

  const termsCondition =
    (requireAgreement && hasCompletedTerms) || !requireAgreement

  return (
    <>
      {showFeedbackModal && (
        <CompletionFeedbackModal
          showModal={showFeedbackModal}
          setShowModal={setShowFeedbackModal}
          courseId={course.id}
        />
      )}
      {showAgreementModal && (
        <CompletionTermsModal
          showModal={showAgreementModal}
          setShowModal={setShowAgreementModal}
          courseId={course.id}
        />
      )}

      {!show && (
        <Button
          className='position-absolute top-0'
          onClick={handleDrawer}
          size='sm'
          style={{ right: `${show ? '50%' : ' 0'}` }}
        >
          <FontAwesomeIcon
            className='cursor-pointer font-weight-bolder text-center'
            icon={faAngleLeft}
            // onClick={close}
          />
        </Button>
      )}
      {show && !course?.hideCourseSidebar && (
        <motion.div
          key='panel'
          className={`drawer position-absolute m-0 col-10 col-sm-8 col-md-6 col-lg-4 ${
            courses.currentTabViewCourse === 'disscusions'
              ? 'col-xl-6'
              : 'col-xl-3'
          } p-0 drawer-absolute top-0 right-0 course-container shadow-sm`}
          initial={{ x: '50%', opacity: 0.4 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          style={{ maxHeight: '90vh', minHeight: '90vh' }}
        >
          <Button
            className='position-absolute top-0'
            onClick={handleDrawer}
            size='sm'
            style={{ left: '-24px' }}
          >
            <FontAwesomeIcon
              className='cursor-pointer font-weight-bolder text-center'
              icon={faAngleRight}
            />
          </Button>
          <Card className='shadow-none border border rounded-0 mb-0 overflow-auto scrollbar h-100'>
            <CardHeader className='border-bottom  align-items-center'>
              <DrawerNav />
            </CardHeader>
            <CardBody className='px-3 position-relative'>
              {course.currentTabViewCourse === 'lessons' && (
                <div className='pb-3'>
                  {course.contentLoading ? (
                    <div className='d-flex align-items-center justify-content-center mt-7'>
                      <Loader
                        color='default'
                        style={{ height: '40px', width: '40px' }}
                      />
                    </div>
                  ) : (
                    <div>
                      {course.allowCourseFeedback === 1 ? (
                        <Rating courseStatus={courseStatus} course={course} />
                      ) : null}
                      {access === 1 &&
                      course.zoom_meeting_url &&
                      course.zoomStartUrl ? (
                        <a
                          target='_blank'
                          href={course.zoomStartUrl}
                          className='tl-icon-btn zoom-btn'
                        >
                          <span>{'Start the Meeting'}</span>
                        </a>
                      ) : null}
                      {access !== 1 && course.zoomJoinUrl ? (
                        <a
                          target='_blank'
                          href={course.zoomJoinUrl}
                          className='tl-icon-btn zoom-btn'
                        >
                          <span>{'Join the Meeting'}</span>
                        </a>
                      ) : null}
                      {isInvited && !isTrainingOver ? (
                        <InPersonTraining
                          course_id={course.course_id}
                          training={course.training}
                          fetchTrainingSession={() =>
                            dispatch(fetchTrainingSession())
                          }
                          checkTraining={checkTraining}
                          isAccepted={isAccepted}
                        />
                      ) : null}
                      {course.selfAssignable && !assignedCourse ? (
                        <Button
                          color='success'
                          style={{ marginBottom: '20px' }}
                          className='position-absolute top-3 right-3'
                          onClick={() =>
                            dispatch(assignUserToCourse(course.course_id))
                          }
                        >
                          Enroll
                        </Button>
                      ) : null}
                      {(() => {
                        const pathSplit =
                          location && location.pathname.split('/')
                        const id = pathSplit[pathSplit.length - 1]
                        const filteredItems = course.content.filter(
                          (item) =>
                            (item.required && !item.completed) ||
                            (isSelfAssignableCourse && !assignedCourse)
                        )
                        const availableItem = filteredItems[0]
                          ? filteredItems[0]
                          : course.content[course.content.length - 1]

                        const sortedContent = [...course.content].sort((a, b) =>
                          a.position > b.position ? 1 : -1
                        )

                        return sortedContent.map((item, index) => (
                          <Link
                            onClick={() => {
                              // Unconditionally call increaseIframeKey
                              dispatch(increaseIframeKey())
                            }}
                            to={`/course/${course.course_id}/${getType(
                              item.type
                            )}/${item.id}`}
                            className={` lessons-link mb-2  d-flex align-items-center py-2	${
                              id == item.id ? ' active' : ''
                            } 
															
															${
                                item.position <= availableItem.position ||
                                !!item.completed ||
                                (courseStatus && courseStatus > 1)
                                  ? ''
                                  : 'disabled-link'
                              } ${item.completed ? 'content_completed' : ''}${
                              item.type === 0 ? ' subtitle-section' : ''
                            }`}
                            key={item.id}
                          >
                            <div
                              style={{
                                fontSize: '14px',
                              }}
                            >
                              <FontAwesomeIcon
                                icon={getIcon(item.type)}
                                className={`drawer-icons icon-sm ${
                                  id == item.id ? ' active' : ''
                                } ${item.completed ? 'content_completed' : ''}`}
                                fixedWidth
                                pull='left'
                              />
                            </div>
                            <span
                              style={{
                                maxWidth: '100%',
                                display: 'block',
                                minHeight: '22px',
                                fontWeight: '600',
                              }}
                              className='tl-item-label truncate ml-2'
                              title={item.title || ''}
                            >
                              {item.title ? (
                                item.title
                              ) : getType(item.type) == 'text' ||
                                getType(item.type) == 'html' ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.html.replace(/<[^>]*>?/gm, ''),
                                  }}
                                />
                              ) : item.content &&
                                item.content[0] &&
                                item.content[0].content ? (
                                item.content[0].content.name
                              ) : (
                                item.content[0].originalFileName
                              )}
                            </span>
                          </Link>
                        ))
                      })()}
                      {console.log(
                        currentCourse,
                        course.content[course.content.length - 1]?.completed,
                        currentCourse?.status,
                        'leart371'
                      )}
                      {(() => {
                        if (
                          currentCourse &&
                          course.content[course.content.length - 1]
                            ?.completed == true &&
                          termsCondition
                        ) {
                          if ([1, 2].includes(currentCourse.status)) {
                            if (
                              course.course_id &&
                              course.quiz.questions &&
                              course.quiz.questions.length &&
                              (userQuiz.status !== 1 ||
                                (userQuiz.status !== 2 && course.quiz.retake))
                            ) {
                              if (allowedAttempts) {
                                if (
                                  !userQuiz.quizAttempts ||
                                  userQuiz.quizAttempts < allowedAttempts
                                ) {
                                  return (
                                    <div className='quiz-retake-button '>
                                      <Modal
                                        toggle={() => toggleShowModal()}
                                        isOpen={showModal}
                                        centered
                                      >
                                        <CustomModalHeader
                                          title='Are you sure you want to take the quiz?'
                                          toggle={() => toggleShowModal()}
                                        />
                                        <ModalBody></ModalBody>
                                        <CustomModalFooter>
                                          <Link
                                            to={`/course/${course.id}/quiz?index=0`}
                                            onClick={() => toggleShowModal()}
                                            className='btn btn-info mr-1'
                                          >
                                            Yes
                                          </Link>
                                          <SubmitModalButton
                                            text='No'
                                            customFn={() => toggleShowModal()}
                                          />
                                        </CustomModalFooter>
                                      </Modal>
                                      <Button
                                        //  to={`/course/${course.id}/quiz?index=0`}
                                        // onClick={() =>
                                        //   dispatch(setQuizCloseOverlay(false))
                                        // }
                                        onClick={toggleShowModal}
                                        className='btn border border-info btn-block mb-1 mt-3'
                                        style={{
                                          marginRight: '4px',
                                        }}
                                      >
                                        <span className='btn-text'>
                                          {[1, 2].includes(userQuiz.status)
                                            ? language.courses
                                              ? language.courses.retake_quiz
                                              : null
                                            : userQuiz.status === null
                                            ? 'resume quiz'
                                            : language.courses
                                            ? language.courses.take_quiz
                                            : null}
                                        </span>
                                      </Button>
                                    </div>
                                  )
                                }
                              } else {
                                return (
                                  <div className='quiz-retake-button '>
                                    <Modal
                                      toggle={() => toggleShowModal()}
                                      isOpen={showModal}
                                      centered
                                    >
                                      <CustomModalHeader
                                        title='Are you sure you want to take the quiz?'
                                        toggle={() => toggleShowModal()}
                                      />
                                      <ModalBody></ModalBody>
                                      <CustomModalFooter>
                                        <Link
                                          to={`/course/${course.id}/quiz?index=0`}
                                          onClick={() => toggleShowModal()}
                                          className='btn btn-info mr-1'
                                        >
                                          Yes
                                        </Link>
                                        <SubmitModalButton
                                          text='No'
                                          customFn={() => toggleShowModal()}
                                        />
                                      </CustomModalFooter>
                                    </Modal>
                                    <Button
                                      //  to={`/course/${course.id}/quiz?index=0`}
                                      // onClick={() =>
                                      //   dispatch(setQuizCloseOverlay(false))
                                      // }
                                      onClick={toggleShowModal}
                                      className='btn border border-info btn-block mb-1 mt-3'
                                      style={{
                                        marginRight: '4px',
                                      }}
                                    >
                                      <span className='btn-text'>
                                        {[1, 2].includes(userQuiz.status)
                                          ? language.courses
                                            ? language.courses.retake_quiz
                                            : null
                                          : userQuiz.status === null
                                          ? 'resume quiz'
                                          : language.courses
                                          ? language.courses.take_quiz
                                          : null}
                                      </span>
                                    </Button>
                                  </div>
                                )
                              }
                            }
                          }
                        }
                      })()}
                      {(() => {
                        if (
                          course.content[course.content.length - 1]
                            ?.completed == true &&
                          !termsCondition
                        ) {
                          return (
                            <div className='agreement-button'>
                              <Button
                                onClick={() => setShowAgreementModal(true)}
                                className='btn border border-info btn-block mb-1 mt-3'
                                style={{
                                  marginRight: '4px',
                                }}
                              >
                                <span className='btn-text'>
                                  Complete Terms & Conditions
                                </span>
                              </Button>
                            </div>
                          )
                        }
                      })()}
                      <div className='content__buttons__container d-flex gap06 w-100'>
                        {(course.course_id &&
                          [1, 2].includes(userQuiz.status)) ||
                        (userQuiz.quizTimer && userQuiz.quizOpened) ? (
                          <div className='quiz-retake-button text-center flex-grow-1'>
                            <Button
                              color='info'
                              outline
                              onClick={() => setShowViewSubmission(true)}
                              className='btn border border-info btn-block'
                            >
                              <span className='btn-text'>
                                {language.courses
                                  ? language.courses.view_submission
                                  : null}
                              </span>
                            </Button>
                          </div>
                        ) : null}

                        <Modal
                          isOpen={showViewSubmission}
                          toggle={() => setShowViewSubmission(false)}
                          size='xl'
                          centered
                          scrollable
                        >
                          <ModalHeader
                            className='border-bottom'
                            toggle={() => setShowViewSubmission(false)}
                          >
                            <span className='text-info font-weight-bold'>
                              {language.courses
                                ? language.courses.total_points
                                : null}
                              : {userQuiz.quiz_score || 0} /
                              {userQuiz.submissions &&
                              userQuiz.submissions.length
                                ? userQuiz.submissions
                                    .map((item) => parseInt(item.points))
                                    .reduce((total, value) => total + value) ||
                                  0
                                : null}
                            </span>
                          </ModalHeader>
                          <ModalBody
                            className='scrollbar'
                            style={{ height: '450px' }}
                          >
                            <div className='col-md-10 mt-2'>
                              <span
                                className='submission-message'
                                style={{
                                  color:
                                    userQuiz.progress_status === 2
                                      ? '#ff0000'
                                      : userQuiz.progress_status === 3
                                      ? '#46b943'
                                      : '#000',
                                }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    userQuiz.quiz_score_percentage >=
                                    userQuiz.quiz_pass_percentage
                                      ? language.courses.success_quiz_message
                                      : userQuiz.message,
                                }}
                              />
                              <br />

                              <div className='row mt-4'>
                                {userQuiz.submissions &&
                                userQuiz.submissions.length
                                  ? userQuiz.submissions.map(
                                      (question, index) => (
                                        <Question
                                          {...question}
                                          isSubmission={courses?.isSubmission}
                                          quizPassed={courses?.quizPassed}
                                          key={index}
                                          language={courses?.language}
                                        >
                                          {(() => {
                                            return (question.options || []).map(
                                              (optionItem, optionIndex) =>
                                                question.type !== 5 &&
                                                question.type !== 8 ? (
                                                  <div
                                                    key={`${question.id}-${optionIndex}`}
                                                    className='question-row'
                                                  >
                                                    {question.type === 3 ? (
                                                      <InputCheckbox
                                                        {...courses}
                                                        question={question}
                                                        item={optionItem}
                                                        index={optionIndex}
                                                        disabled
                                                      />
                                                    ) : question.type ===
                                                      4 ? null : (
                                                      <InputRadio
                                                        {...courses}
                                                        question={question}
                                                        item={optionItem}
                                                        index={optionIndex}
                                                        disabled
                                                      />
                                                    )}
                                                    {question.type !== 5 ? (
                                                      question.type === 6 ? (
                                                        <span className='image-option-wrapper'>
                                                          <img
                                                            className={`submitted-image-option ${
                                                              optionItem.selected
                                                                ? 'image-option-selected'
                                                                : ''
                                                            }`}
                                                            src={
                                                              optionItem.url ||
                                                              ''
                                                            }
                                                          />
                                                        </span>
                                                      ) : null
                                                    ) : null}

                                                    {question.type !== 5 ? (
                                                      question.type === 6 ? (
                                                        <span className='image-option-wrapper'>
                                                          <img
                                                            className={`submitted-image-option ${
                                                              optionItem.selected
                                                                ? 'image-option-selected'
                                                                : ''
                                                            }`}
                                                            src={`${
                                                              optionItem.url
                                                                ? optionItem.url
                                                                : ''
                                                            }`}
                                                          />
                                                        </span>
                                                      ) : question.type ===
                                                        1 ? (
                                                        <label
                                                          htmlFor={
                                                            optionItem.id
                                                          }
                                                        >
                                                          {optionItem.value ===
                                                          1
                                                            ? language.courses
                                                              ? language.courses
                                                                  .true
                                                              : null
                                                            : language.courses
                                                            ? language.courses
                                                                .false
                                                            : null}
                                                        </label>
                                                      ) : (
                                                        <label
                                                          htmlFor={
                                                            optionItem.id
                                                          }
                                                        >
                                                          {optionItem.name}
                                                        </label>
                                                      )
                                                    ) : null}
                                                    {(() => {
                                                      if (!courses.quizPassed) {
                                                        if (
                                                          question.type === 1 ||
                                                          question.type === 2 ||
                                                          question.type === 6
                                                        ) {
                                                          if (
                                                            optionItem.selected ===
                                                              true &&
                                                            optionItem.id ==
                                                              question.correct_answer
                                                          ) {
                                                            return (
                                                              <FontAwesomeIcon
                                                                icon={faCheck}
                                                                size='md'
                                                                className='icon-answ-correct'
                                                              />
                                                            )
                                                          } else if (
                                                            optionItem.selected
                                                          ) {
                                                            return (
                                                              <FontAwesomeIcon
                                                                icon={faTimes}
                                                                className='icon-answ-incorrect'
                                                              />
                                                            )
                                                          }
                                                        } else if (
                                                          question.type === 3
                                                        ) {
                                                          if (
                                                            optionItem.selected &&
                                                            optionItem.id ===
                                                              optionItem.correct_answer
                                                          ) {
                                                            return (
                                                              <FontAwesomeIcon
                                                                icon={faCheck}
                                                                size='md'
                                                                className='icon-answ-correct'
                                                              />
                                                            )
                                                          } else if (
                                                            optionItem.selected
                                                          ) {
                                                            return (
                                                              <FontAwesomeIcon
                                                                icon={faTimes}
                                                                size='md'
                                                                className='icon-answ-incorrect'
                                                              />
                                                            )
                                                          }
                                                        }
                                                      }
                                                    })()}

                                                    {(() => {
                                                      if (
                                                        question.type === 1 &&
                                                        courses.quizPassed
                                                      ) {
                                                        if (
                                                          courses.quizPassed ===
                                                          -1
                                                        ) {
                                                          if (
                                                            question.answered &&
                                                            optionItem.selected
                                                          ) {
                                                            if (
                                                              optionItem.correct
                                                            ) {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faCheck}
                                                                  size='md'
                                                                  className='icon-answ-correct'
                                                                />
                                                              )
                                                            } else {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faTimes}
                                                                  className='icon-answ-incorrect'
                                                                />
                                                              )
                                                            }
                                                          }
                                                        } else if (
                                                          courses.quizPassed ===
                                                          1
                                                        ) {
                                                          if (
                                                            question.answered
                                                          ) {
                                                            if (
                                                              question.answeredCorrect
                                                            ) {
                                                              if (
                                                                optionItem.correct
                                                              ) {
                                                                return (
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faCheck
                                                                    }
                                                                    size='md'
                                                                    className='icon-answ-correct'
                                                                  />
                                                                )
                                                              }
                                                            } else if (
                                                              optionItem.correct &&
                                                              !optionItem.selected
                                                            ) {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faCheck}
                                                                  size='md'
                                                                  className='icon-answ-correct'
                                                                />
                                                              )
                                                            } else {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faTimes}
                                                                  size='md'
                                                                  className='icon-answ-incorrect'
                                                                />
                                                              )
                                                            }
                                                          }
                                                        }
                                                      }
                                                    })()}

                                                    {(() => {
                                                      if (
                                                        question.type === 2 ||
                                                        (question.type === 6 &&
                                                          courses.quizPassed)
                                                      ) {
                                                        if (
                                                          courses.quizPassed ===
                                                          -1
                                                        ) {
                                                          if (
                                                            question.answered &&
                                                            optionItem.selected
                                                          ) {
                                                            if (
                                                              optionItem.correct
                                                            ) {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faCheck}
                                                                  size='md'
                                                                  className='icon-answ-correct'
                                                                />
                                                              )
                                                            } else {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faTimes}
                                                                  size='md'
                                                                  className='icon-answ-incorrect'
                                                                />
                                                              )
                                                            }
                                                          }
                                                        } else if (
                                                          courses.quizPassed ===
                                                          1
                                                        ) {
                                                          if (
                                                            question.answered
                                                          ) {
                                                            if (
                                                              question.answeredCorrect
                                                            ) {
                                                              if (
                                                                optionItem.correct
                                                              ) {
                                                                return (
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faCheck
                                                                    }
                                                                    size='md'
                                                                    className='icon-answ-correct'
                                                                  />
                                                                )
                                                              }
                                                            } else if (
                                                              optionItem.correct
                                                            ) {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faCheck}
                                                                  size='md'
                                                                  className='icon-answ-correct'
                                                                />
                                                              )
                                                            } else if (
                                                              !optionItem.correct &&
                                                              optionItem.selected
                                                            ) {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faTimes}
                                                                  size='md'
                                                                  className='icon-answ-incorrect'
                                                                />
                                                              )
                                                            }
                                                          }
                                                        }
                                                      }
                                                    })()}

                                                    {(() => {
                                                      if (
                                                        question.type === 3 &&
                                                        courses.quizPassed
                                                      ) {
                                                        if (
                                                          courses.quizPassed ===
                                                          -1
                                                        ) {
                                                          if (
                                                            optionItem.answered
                                                          ) {
                                                            if (
                                                              optionItem.correct
                                                            ) {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faCheck}
                                                                  size='md'
                                                                  className='icon-answ-correct'
                                                                />
                                                              )
                                                            } else {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faTimes}
                                                                  size='md'
                                                                  className='icon-answ-incorrect'
                                                                />
                                                              )
                                                            }
                                                          }
                                                        } else if (
                                                          courses.quizPassed ===
                                                          1
                                                        ) {
                                                          if (
                                                            !optionItem.answered
                                                          ) {
                                                            if (
                                                              optionItem.correct
                                                            ) {
                                                              return (
                                                                <span>
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faTimes
                                                                    }
                                                                    size='md'
                                                                    className='icon-answ-incorrect'
                                                                  />
                                                                  <label className='hint-text'>
                                                                    {language.general
                                                                      ? language
                                                                          .general
                                                                          .not_selected
                                                                      : null}
                                                                  </label>
                                                                </span>
                                                              )
                                                            }
                                                          } else {
                                                            if (
                                                              optionItem.correct
                                                            ) {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faCheck}
                                                                  size='md'
                                                                  className='icon-answ-correct'
                                                                />
                                                              )
                                                            } else {
                                                              return (
                                                                <FontAwesomeIcon
                                                                  icon={faTimes}
                                                                  size='md'
                                                                  className='icon-answ-incorrect'
                                                                />
                                                              )
                                                            }
                                                          }
                                                        }
                                                      }
                                                    })()}

                                                    {question.type === 4 ? (
                                                      question.correctAnswer &&
                                                      optionItem.id ===
                                                        question.correctAnswer[
                                                          optionIndex
                                                        ].id ? (
                                                        <FontAwesomeIcon
                                                          icon={faCheck}
                                                          size='md'
                                                          className='icon-answ-correct'
                                                        />
                                                      ) : (
                                                        <FontAwesomeIcon
                                                          icon={faTimes}
                                                          size='md'
                                                          className='icon-answ-incorrect'
                                                        />
                                                      )
                                                    ) : null}

                                                    {[1, 2].includes(
                                                      question.type
                                                    ) &&
                                                    question.answered &&
                                                    optionItem.selected &&
                                                    optionItem.description &&
                                                    optionItem.description !==
                                                      String.fromCharCode(
                                                        160
                                                      ) ? (
                                                      <div className='option-feedback'>
                                                        <div
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              optionItem.description,
                                                          }}
                                                        />
                                                        <FontAwesomeIcon
                                                          icon={faInfoCircle}
                                                          className='info-icon'
                                                        />
                                                      </div>
                                                    ) : null}
                                                  </div>
                                                ) : optionItem &&
                                                  optionItem.type === 1 ? (
                                                  <div
                                                    key={`${question.id}-${optionIndex}`}
                                                    className='question-row'
                                                  >
                                                    <div className='col-xl-6 matching-options-wrapper'>
                                                      <div className='matching-options-container'>
                                                        <label
                                                          htmlFor={
                                                            optionItem.id
                                                          }
                                                        >
                                                          {optionItem.name}
                                                        </label>
                                                        {(() => {
                                                          const answer =
                                                            question.options.find(
                                                              (item) =>
                                                                item.id ===
                                                                optionItem.selected
                                                            )

                                                          return answer ? (
                                                            <label
                                                              htmlFor={
                                                                optionItem.id
                                                              }
                                                            >
                                                              {answer.name}
                                                            </label>
                                                          ) : (
                                                            <label className='hint-text'>
                                                              {language.courses
                                                                ? language
                                                                    .courses
                                                                    .no_option_selected
                                                                : null}
                                                            </label>
                                                          )
                                                        })()}
                                                        {(() => {
                                                          const answer =
                                                            question.options.find(
                                                              (item) =>
                                                                item.id ===
                                                                optionItem.selected
                                                            )

                                                          return optionItem.selected &&
                                                            optionItem.id ===
                                                              answer.match &&
                                                            optionItem.selected ===
                                                              answer.id ? (
                                                            <FontAwesomeIcon
                                                              icon={faCheck}
                                                              size='md'
                                                              className='icon-answ-correct'
                                                            />
                                                          ) : optionItem.selected ? (
                                                            <FontAwesomeIcon
                                                              icon={faTimes}
                                                              size='md'
                                                              className='icon-answ-incorrect'
                                                            />
                                                          ) : null
                                                        })()}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null
                                            )
                                          })()}

                                          {question.type === 7 && (
                                            <p>{question.answer}</p>
                                          )}

                                          {question.type === 8 && (
                                            <GridQuestions
                                              editMode={false}
                                              viewMode={true}
                                              tableData={question.tableData}
                                              gradedScores={question.scores}
                                            />
                                          )}
                                        </Question>
                                      )
                                    )
                                  : null}
                              </div>
                            </div>
                          </ModalBody>
                        </Modal>
                        {course.redirect_url ? (
                          <a
                            target='_blank'
                            title='Revisit external course'
                            style={{
                              marginTop: '20px',
                              width: '100%',
                            }}
                            className='btn btn-info btn-info'
                            // href={`${course.redirect_url}?firstname=${
                            // 	this.props.user.first_name
                            // }&lastname=${
                            // 	this.props.user.last_name
                            // }&language=en_US&courseid=${this.props.id}&kid=${
                            // 	this.props.user && this.props.user.id
                            // }`}
                            href='#'
                          >
                            {language.courses
                              ? language.courses.revisit_course
                              : null}
                          </a>
                        ) : null}
                        {(() => {
                          return showCert ? (
                            <div>
                              <Certificate
                                course={course}
                                certificateShowing={course.certificateShowing}
                                employee={user}
                                logoUrl={theme?.logo?.url}
                                navLogo={theme?.navlogo}
                                language={language}
                                certificateType={general?.certificateType}
                                setBlink={setBlink}
                              />
                            </div>
                          ) : null
                        })()}
                        {(() => {
                          let courseStatus = null

                          const currentCourseProgress =
                            course.userProgress.find(
                              (item) => item.course_id === course.course_id
                            )
                          if (currentCourseProgress) {
                            courseStatus = currentCourseProgress.status
                          }
                          if (
                            courseStatus === 4 &&
                            courseConfig.enableCourseGeneratingCertificate === 1
                          ) {
                            return (
                              <div className='flex-grow-1'>
                                {course?.doNotShowCertificate === 0 ? (
                                  <Button
                                    onMouseEnter={() => setBlink(false)}
                                    onMouseLeave={() => setBlink(true)}
                                    onClick={() => {
                                      setShowCert(true)
                                      dispatch(setShowCertificate())
                                    }}
                                    color='info'
                                    outline
                                    block
                                    className={
                                      shouldCertificateBlink && blink
                                        ? 'blink'
                                        : ''
                                    }
                                  >
                                    {language.courses
                                      ? language.courses.certificate
                                      : null}
                                  </Button>
                                ) : null}
                                {course.allowCourseFeedback === 1 &&
                                ![1, 2].includes(user.access) ? (
                                  <span
                                    onClick={() =>
                                      dispatch(toggleFeedbackOverlay())
                                    }
                                    className='leave-feedback text-info mt-2'
                                  >
                                    {!course.selfCourseFeedbackData
                                      ? 'Leave a review'
                                      : ''}
                                  </span>
                                ) : null}
                                {course.isFeedbackOverlayShowing ? (
                                  <FeedbackOverlay
                                    {...course}
                                    language={language}
                                    access={user.access}
                                  />
                                ) : null}
                              </div>
                            )
                          }
                        })()}
                      </div>
                      {course.allowCourseFeedback === 1 &&
                      [1, 2].includes(access) ? (
                        <span
                          onClick={
                            !course.selfCourseFeedbackData
                              ? () => dispatch(toggleFeedbackOverlay())
                              : null
                          }
                          className='leave-feedback text-info mt-2'
                        >
                          {!course.selfCourseFeedbackData
                            ? 'Leave a review'
                            : ''}
                        </span>
                      ) : null}
                      {course.isFeedbackOverlayShowing ? (
                        <FeedbackOverlay
                          {...course}
                          language={language}
                          access={user.access}
                        />
                      ) : null}
                    </div>
                  )}
                </div>
              )}
              {course.currentTabViewCourse === 'notes' && (
                <Notes language={language} />
              )}
              {course.currentTabViewCourse === 'disscusions' && (
                <DiscussionForum
                  language={language}
                  courseId={course.course_id}
                />
              )}
            </CardBody>
          </Card>
        </motion.div>
      )}
    </>
  )
}

export default Drawer

const getType = (type) => {
  switch (type) {
    case 0:
      return 'subtitle'
    case 1:
      return 'text'
    case 2:
      return 'video'
    case 4:
      return 'file'
    case 5:
      return 'html'
    case 8:
      return 'scorm'
    case 9:
      return 'lti'
    case 10:
      return 'content-quiz'
  }
}

const getIcon = (type) => {
  switch (type) {
    case 0:
      return faHeading
    case 1:
      return faFont
    case 2:
      return faVideo
    case 4:
      return faFile
    case 5:
      return faCode
    case 8:
      return faFileArchive
    case 9:
      return faLink
  }
}
